import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import Image from 'next/image';

type FrontendItem = {
    text: string;
    icon: string;
};

type LayoutPageProps = {
    listFrontend: FrontendItem[];
};
const Solution = ({ listFrontend }: LayoutPageProps) => {
    return (
        <div className="skills-solution">
            <FullWrapper>
                <div className="skills-solutionWrapper">
                    <div className="skills-solutionInner">
                        <div className="skills-solutionLeft">
                            <div className="skills-solutionDescriptionTop">
                                Многие компании применяют системы грейдов для оценки сотрудников,
                                но&nbsp;часто эти процессы ведутся вручную, через таблицы, документы
                                и&nbsp;другие несинхронизированные инструменты. Это приводит
                                к&nbsp;неактуальным данным о&nbsp;развитии сотрудников, сложностям
                                в&nbsp;управлении карьерными траекториями и&nbsp;отсутствию
                                централизованного подхода.
                            </div>
                            <div className="skills-solutionDescriptionTop">
                                Агентство &laquo;Вебпрактик&raquo; также столкнулось с&nbsp;этой
                                проблемой и&nbsp;нуждалось в&nbsp;автоматизации процессов управления
                                компетенциями. В&nbsp;итоге через свою боль мы&nbsp;создали продукт,
                                которым успешно поделились с&nbsp;рынком.
                            </div>
                        </div>
                        <div className="skills-solutionRight">
                            SkillsTeam упрощает и&nbsp;стандартизирует управление грейдами, делая
                            процесс прозрачным и&nbsp;справедливым как для сотрудников, так
                            и&nbsp;для компаний.
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <FullWrapper>
                <div className="skills-solutionWrapper">
                    <div className="skills-solutionTitle">Решение</div>
                    <div className="skills-solutionInner">
                        <div className="skills-solutionLeft">
                            <div className="skills-solutionDescription">
                                На&nbsp;старте работы над проектом четко определили бизнес-цели, что
                                стало основой для дальнейших шагов. Провели детальный анализ
                                российского и&nbsp;зарубежного опыта, выявили &laquo;боли&raquo;,
                                запросы и&nbsp;требования В2В-клиентов, что обеспечило понимание
                                задач нашей целевой аудитории. На&nbsp;следующем этапе разработали
                                матрицы компетенций для ключевых профессий: фронтенд-
                                и&nbsp;бекенд-разработчики, QA, аналитик.
                            </div>
                            <div className="skills-solutionDescription">
                                Автоматизировали процесс грейдирования и&nbsp;наставничества,
                                добавили визуализацию данных и&nbsp;метрик в&nbsp;виде диаграмм
                                и&nbsp;дашбордов для удобного восприятие информации о&nbsp;развитии
                                сотрудников и&nbsp;получения наглядных и&nbsp;информативных отчетов.
                            </div>
                        </div>
                        <div className="skills-solutionRight">
                            <div className="skills-solutionRightText">
                                Проект разработан на&nbsp;стеке nextjs(react)/nodejs/postgresql
                                и&nbsp;развернут с&nbsp;помощью kubernetes. Поставка кода
                                в&nbsp;облако клиента осуществляется с&nbsp;помощью готовых
                                docker-образов.
                            </div>
                            <div className="skills-solutionRightItems">
                                {listFrontend.map((item, index) => (
                                    <div className="skills-solutionRightItem" key={index}>
                                        <img
                                            src={item.icon}
                                            alt="icon"
                                            className="skills-solutionRightIcon"
                                        />
                                        <div className="skills-solutionRightName">{item.text}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="skills-solutionInner">
                        <div className="skills-solutionLeft">
                            <div className="skills-solutionDescriptionBottom">
                                На&nbsp;следующем этапе спроектировали архитектуру платформы,
                                создали дизайн-концепцию и&nbsp;разработали интерфейсы для разных
                                ролей.
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <div className="skills-solutionPath">
                <FullWrapper isMargin={false}>
                    <div className="skills-solutionWrapper">
                        <div className="skills-solutionBlock">
                            <div className="skills-solutionContent">
                                <div className="skills-solutionTitlePath">
                                    От&nbsp;идеи до&nbsp;релиза
                                </div>
                                <div className="skills-solutionDescriptionPath">
                                    Запуск продукта SkillsTeam состоялся в&nbsp;июне 2024 год
                                </div>
                            </div>
                            <div className="skills-solutionItem">
                                <Image
                                    src="/images/pic/skills-team/skillsT.png"
                                    alt="cloud system"
                                    width={1402}
                                    height={636}
                                    className="skills-solutionImg"
                                />
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
        </div>
    );
};

export default Solution;
